<template>
    <input @change="onGlobalFilter"
           class="form-control table-search"
           placeholder="Search..."
           v-model="globalFilter" />
</template>
<script>
    export default {
        data() {
            return {
                globalFilter: ''
            }
        },
        methods:{
            async onGlobalFilter() {
                this.$parent.isLoading = true
                this.$parent.updateParams({filterGlobal: this.globalFilter});
                await this.$parent.loadItems();
                this.$parent.isLoading = false
            }
        }
    }
</script>
